export const MY_PROFILE = "my-profile";
export const MY_FAMILY = "my-family";
export const CHANGE_PASSWORD = "change-password";
export const SUPPORT = "support";
export const MY_REVIEWS = "my-reviews";
export const INSURANCE = "insurance";
export const NOTIFICATION_PREFERENCE = "notification-preference";
export const SETTINGS = "setting";
